import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Modal, Alert, Table, Form, Row, Col, Spinner } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { ViewManager } from '../../../core/view-manager';
import { Utils } from '../../../core/utils';
import * as XLSX from 'xlsx';
import { renderSync } from 'sass';




export default function DGLTH_shipping_plan({ item, entity = null, refreshData }) {

    const navigate = useNavigate();

    const [modalShippingPlanBookItemsStatus, setModalShippingPlanBookItemsStatus] = useState(false);
    function shippingPlanBookItems() {
        console.log(item)
        setModalShippingPlanBookItemsStatus(true)
    }
    async function handleConfirmShippingPlanBookItems() {
        // cambio status shipping_plan
        const id = toast.loading("In corso...")
        var body = {
            status: { value: '10_BOOKED' }
        }
        var response = await DataManager.updateItem('shipping_plan', body, item.id)
        if (response.success === 1) {
            toast.update(id, { render: "Piano di consegna confermato.", type: "success", isLoading: false, autoClose: 2000 });
            item.status = { value: '10_BOOKED' }

            setModalShippingPlanBookItemsStatus(false)
            refreshData();
        }
        else {
            toast.update(id, { render: "Errore.", type: "error", isLoading: false, autoClose: 2000 });
        }
    }

    /** ddt */
    const [modalGenerateCustomerDdtStatus, setModalGenerateCustomerDdtStatus] = useState(false);
    function handleGenerateCustomerDdt() {
        // cambio status shipping_plan
        navigate('/page/ShippingPlanInvoices?id=' + item.id)
    }



    /** genera documenti */
    async function generateDocument() {
        if (item.itemsAspect !== "") {

            var sorting = {
                'field': 'id',
                'order': 'asc'
            }
            let constraints = [
                { fieldName: "idShippingPlan", type: "value", value: item.id }
            ]
            var res = await DataManager.searchItems('shipping_plan_rows', 1, 1000, sorting, '', [], constraints);
            if (res.success === 1) {

                const initialArray = res.body;
                const grouped = Object.values(
                    initialArray.reduce((acc, item) => {
                        // Se la chiave non esiste ancora, inizializzala
                        if (!acc[item.idOrder]) {
                            acc[item.idOrder] = { idOrder: item.idOrder, rows: [] };
                        }
                        // Aggiungi l'elemento alle righe del gruppo
                        acc[item.idOrder].rows.push(item);
                        return acc;
                    }, {})
                );

                for (let j = 0; j < grouped.length; j++) {
                    var rows = []
                    var order = grouped[j].idOrder
                    var orderRows = grouped[j].rows
                    for (let i = 0; i < orderRows.length; i++) {
                        var row = {
                            idCustomerOrderRow: { id: orderRows[i].idRow },
                            code: orderRows[i].code,
                            description: orderRows[i].description,
                            quantity: orderRows[i].quantity,
                            price: orderRows[i].total,
                            code: orderRows[i].code,
                            notes: null,
                            fulfilledQuantity: orderRows[i].fulfilledQuantity
                        }
                        rows.push(row);
                    }
                    const total = orderRows.reduce((acc, cur) =>
                        acc + parseFloat(cur.total)
                        , 0)
                    const weight = orderRows.reduce((acc, cur) =>
                        acc + parseFloat(cur.netWeight)
                        , 0)

                    const packages = orderRows.reduce((acc, cur) =>
                        acc + parseFloat(cur.packages)
                        , 0)
                    const volume = orderRows.reduce((acc, cur) =>
                        acc + parseFloat(cur.volume)
                        , 0)


                    var data = {
                        idCustomerOrder: order ,
                        idShippingPlan: { id: item.id },
                        packagesQuantity: packages,
                        weight: parseFloat(weight),
                        volume: parseFloat(volume),
                        forwarder: item.idForwarder ? (item.idForwarder.name || item.idForwarder.label || "") : null,
                        itemsAspect: { value: item.itemsAspect && item.itemsAspect.value || null },
                        transportBy: { value: item.transportBy && item.transportBy.value || null },
                        status: { value: '0_PENDING' },
                        total: parseFloat(total).toFixed(2),
                        rows: rows
                    }
                    console.log(data)

                    var res = await DataManager.insertItem('customer_transport_document', data);
                    console.log(res)
                    if (res.success === 1) {
                        toast.success("Documento generato con successo per l'ordine con id " + order, { theme: 'colored', autoClose: 500 })
                    }
                }
            }
        } else {
            toast.error('Inserire il campo Aspetto beni per proseguire', { theme: 'colored' })
        }

    }

    /** visualizza / elimina righe */
    const [statusModalDelete, setStatusModalDelete] = useState(false);
    const [rows, setRows] = useState(null);
    function closeModalDelete() {
        setStatusModalDelete(false)
        refreshData()
    }

    function openModalDelete() {
        setStatusModalDelete(true)
    }

    const [searchableFields, setSearchableFields] = useState(['customer', 'code', 'quantity', 'description', 'packages'])
    const [inputSearch, setInputSearch] = useState("");
    const [tempId, setTempId] = useState(null);

    async function getRows(shippingPlan) {
        console.log('AAA', shippingPlan, tempId)
        setTempId(shippingPlan)
        let constraints = [{ fieldName: "idShippingPlan", type: "value", value: shippingPlan.id }]
        var sorting = {
            'field': 'id',
            'order': 'asc'
        }
        var res = await DataManager.searchItemsSimple('shipping_plan_rows', 1, 1000, sorting, inputSearch, searchableFields, constraints);
        console.log('RES', res.body)
        if (res.success === 1) {
            // Enrich each row with the related customer order internal code
            const enriched = await Promise.all((res.body || []).map(async (r) => {
                try {
                    if (r.idOrder) {
                        const orderRes = await DataManager.getItemSimple('customer_order', r.idOrder);
                        if (orderRes.success === 1 && orderRes.body && orderRes.body[0]) {
                            return { ...r, orderInternalCode: orderRes.body[0].internalCode };
                        }
                    }
                } catch (e) {
                    console.warn('Failed to fetch order for row', r, e);
                }
                return { ...r, orderInternalCode: null };
            }));
            setRows(enriched);
            if (res.body.length > 0) {
                if (statusModalDelete === false) {
                    openModalDelete();
                }
            } else {
                toast.error('Questo piano non ha righe al suo interno', { theme: 'colored' })
            }
        } else {
            toast.error('Errore nel caricamento delle righe', { theme: 'colored' })
        }
    }

    async function deleteRow(item) {
        console.log(item)
        var res = await DataManager.deleteItem('shipping_plan_rows', item.id);
        if (res.success === 1) {
            var dataUpdate = {
                idShippingPlan: 0
            }
            var r = await DataManager.updateItem('customer_order_rows', dataUpdate, item.idRow)
            console.log(r)
            if (r.success === 1) {
                toast.success('Riga rimossa con successo!', { theme: 'colored' })
                getRows(tempId)
            }

        }
    }

    useEffect(() => {
        if (statusModalDelete) {
            console.log(item)
            getRows(item.id)
        }
    }, [inputSearch])


    function exportRighe() {
        if (rows !== null) {
            const worksheet = XLSX.utils.json_to_sheet(rows);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Righe');
            XLSX.writeFile(workbook, 'righe_piano_di_carico.xlsx');
        }
    }

    function report() {
        navigate('/page/ReportPianoDiCarico?id=' + item.id)
    }

    const [loadingPickingList, setLoadingPickingList] = useState(false);
    async function goToPickingList() {
        const toastId = toast.loading('Preparazione lista di carico...');
        setLoadingPickingList(true);
        try {
            const temp = [];
            const res = await DataManager.getItem('shipping_plan', item.id);
            if (res.success && res.body && res.body[0] && Array.isArray(res.body[0].rows)) {
                for (let i = 0; i < res.body[0].rows.length; i++) {
                    temp.push(res.body[0].rows[i].idCustomerOrderRow.id);
                }
            } else {
                throw new Error('Nessuna riga trovata per il piano di carico');
            }

            // Apri la picking list in una nuova finestra
            window.open('/page/PickingList?id=' + temp.toString());

            toast.update(toastId, { render: 'Apertura lista di carico...', type: 'success', isLoading: false, autoClose: 1000 });
        } catch (e) {
            console.error(e);
            toast.update(toastId, { render: e.message || 'Errore durante la preparazione', type: 'error', isLoading: false, autoClose: 2500 });
        } finally {
            setLoadingPickingList(false);
        }
    }





    return (
        <>
            {item.status && item.status.value === '0_DRAFT' && (
                <Button onClick={shippingPlanBookItems} variant='success' size='sm'><FontAwesomeIcon className='me-2' icon={'circle-check'} />Conferma</Button>
            )}
            {item.status && item.status.value !== '0_DRAFT' && (
                <Button onClick={generateDocument} className='m-1' variant='secondary' size='sm'><FontAwesomeIcon icon={'file-lines'} className='me-1' />Genera documenti</Button>
            )}


            <Button variant='info' size='sm' className='m-1' onClick={() => { goToPickingList(item) }}>Lista di carico</Button>
            <Button variant='outline-dark' size='sm' className='m-1' onClick={() => { getRows(item) }}>Visualizza righe</Button>
            <Button variant='outline-secondary' size='sm' className='m-1' onClick={() => { report() }}>Report</Button>


            {modalShippingPlanBookItemsStatus !== false ? (
                <Modal show={modalShippingPlanBookItemsStatus} onHide={() => setModalShippingPlanBookItemsStatus(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Conferma piano di consegna</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Confermi questo piano di consegna?<br />
                        Non potrai più aggiungere righe.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setModalShippingPlanBookItemsStatus(false)}>
                            Chiudi
                        </Button>
                        <Button variant="primary" onClick={handleConfirmShippingPlanBookItems}>
                            Conferma
                        </Button>
                    </Modal.Footer>
                </Modal>
            ) : (
                <></>
            )}

            {modalGenerateCustomerDdtStatus !== false ? (
                <Modal show={modalGenerateCustomerDdtStatus} onHide={() => setModalGenerateCustomerDdtStatus(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Conferma richiesta</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Confermi di voler generare le fatture accompagnatorie per questo piano di consegna?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setModalGenerateCustomerDdtStatus(false)}>
                            Chiudi
                        </Button>
                        <Button variant="primary" onClick={handleGenerateCustomerDdt}>
                            Conferma
                        </Button>
                    </Modal.Footer>
                </Modal>
            ) : (
                <></>
            )}

            {statusModalDelete !== false ? (
                <Modal show={statusModalDelete} onHide={closeModalDelete} size='xl'>
                    <Modal.Header closeButton>
                        <Modal.Title>Rimuovi righe</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={11}>
                                <Form.Control type="text" placeholder="Cerca..." onChange={(e) => { setInputSearch(e.target.value) }} className='mb-3' />
                            </Col>
                            <Col md={1} className='ps-0'>
                                <Button variant='success' onClick={() => { exportRighe() }}>Esporta</Button>
                            </Col>
                        </Row>

                        <Table bordered striped={true} className='small'>
                            <thead>
                                <tr>
                                    <th>Cliente</th>
                                    <th>N. Ordine</th>
                                    <th>Codice articolo</th>
                                    <th>Descrizione articolo</th>
                                    <th>Quantità</th>
                                    <th>Colli</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows && rows.map((item, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{item.customer}</td>
                                            <td>{item.orderInternalCode || ''}</td>
                                            <td>{item.code}</td>
                                            <td>{item.description}</td>
                                            <td>{item.quantity}</td>
                                            <td>{item.packages}</td>
                                            <td><Button variant='danger' size='sm' onClick={() => { deleteRow(item) }}>Rimuovi</Button></td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                        {rows && rows.length === 0 ? <>
                            <Alert variant={'warning'}>
                                Nessuna riga trovata!
                            </Alert>
                        </> : <></>}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeModalDelete}>
                            Chiudi
                        </Button>
                    </Modal.Footer>
                </Modal>
            ) : (
                <></>
            )}


        </>
    )
};
